module.exports = __webpack_public_path__ + "static/img/ba.32231661.svg";